<template>
    <v-card>
        <v-card-title>Add User to role</v-card-title>
        <v-card-text>
            <UserSearch 
                outlined
                hide-details
                v-model="user"
            />
        </v-card-text>
        <v-card-actions>
            <v-btn 
                @click="handleSave"
                color="primary" 
                >save</v-btn>
            <v-btn 
                depressed 
                text
                @click="handleCancel"
                >cancel</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import roleUser from './../../services/administration/roleUser'
import UserSearch from './../searchComponents/UserSearch'
export default {
    props: {
        role: Number
    },
    components: {
        UserSearch
    },
    data() {
        return {
            user: null
        }
    },
    methods: {
        handleSave() {
            roleUser.store({role_id : this.role, user_id: this.user}).then(response => {
                this.$emit("success", response.data.message)
            })
        },
        handleCancel() {
            this.$emit("cancel")
        }
    },
    mounted() {

    }
}
</script>


<style>

</style>